import { useQuery } from "@tanstack/react-query";
import type { DateTime } from "luxon";
import { useAnalytics } from "@/contexts/analytics/hooks";
import { useChosenDepartment } from "@/contexts/ChosenDepartment";
import { backendService } from "@/services/backend.service";
import type { OtMode } from "@/utils/models";
import { MC_QUERY_DEFAULTS } from "../utils";

export const useGetHoursSummary = ({
	sinceDate,
	endDate,
	isActual,
	roles,
	jobs,
	shiftHours,
	excludeHolidays,
	includeEmployeeDetails,
	includeLateScheduled,
	otMode,
	enabled,
}: {
	sinceDate: DateTime;
	endDate?: DateTime;
	isActual: boolean;
	roles?: string[];
	jobs?: string[];
	shiftHours?: string[];
	excludeHolidays?: boolean;
	includeEmployeeDetails?: boolean;
	includeLateScheduled?: boolean;
	otMode?: OtMode;
	enabled?: boolean;
}) => {
	const { chosenDepartment } = useChosenDepartment();
	const { track } = useAnalytics();
	return useQuery({
		queryKey: [
			"hours-summary",
			sinceDate.toFormat("yyyy-MM-dd"),
			endDate?.toFormat("yyyy-MM-dd"),
			chosenDepartment.department_id,
			isActual,
			roles,
			jobs,
			shiftHours,
			excludeHolidays,
			includeEmployeeDetails,
			includeLateScheduled,
			otMode,
		],
		queryFn: async () => {
			track("fetch_hours_summary", {
				department_id: chosenDepartment.department_id,
				sinceDate: sinceDate.toFormat("yyyy-MM-dd"),
				endDate: endDate?.toFormat("yyyy-MM-dd"),
				is_actual: isActual,
				shift_hours: shiftHours?.join(","),
			});
			const result = await backendService.getHoursSummary({
				departmentId: chosenDepartment.department_id,
				startDate: sinceDate,
				endDate,
				isActual,
				roles,
				jobs,
				shiftHours,
				excludeHolidays,
				includeEmployeeDetails,
				includeLateScheduled,
				otMode,
			});
			return result.data;
		},
		...MC_QUERY_DEFAULTS,
		enabled,
	});
};
